<template>
    <div class="card shadow-sm mb-4">
        <div class="card-body px-3 pt-lg-5 px-3 px-lg-4">
            <div class="d-flex flex-row align-items-start mb-4">
                <img src="../../assets/images/setup/home.svg" alt="" class="mr-3">
                <h2> Personal Details</h2>
            </div>
            <div class="form-row">
                <div class="col-12 col-lg-2">
                    <label for="title">Title</label>
                    <select id="title" required v-model.trim="$v.title.$model" class="custom-select custom-select-lg" :class="{'is-invalid' : $v.title.$error || errors.title.length}">
                        <option value="" disabled selected hidden >Title</option>
                        <option v-for="(ttl , k) in titles" :key="k">{{ttl}}</option>
                    </select>
                    <div class="invalid-feedback" v-if="$v.title.$dirty && !$v.title.$required">
                        Please tell us your title!
                    </div>
                    <div class="invalid-feedback" v-for="(err, key) in errors.title" :key="key">{{ err }}</div>
                </div>
                <div class="col-12 col-lg-5">
                    <div class="form-group">
                        <label for="firstName">First Name</label>
                        <input type="text" id="firstName" class="form-control form-control-lg" v-model="$v.firstName.$model" :class="{'is-invalid' : $v.firstName.$error || errors.firstName.length}">
                        <div class="invalid-feedback" v-if="!$v.firstName.$required">
                            Please enter your first name!
                        </div>
                        <div class="invalid-feedback" v-for="(err, key) in errors.firstName" :key="key">{{ err }}</div>
                    </div>
                </div>
                <div class="col-12 col-lg-5">
                    <div class="form-group">
                        <label for="lastName">Last Name</label>
                        <input type="text" id="lastName" class="form-control form-control-lg" v-model="$v.lastName.$model" :class="{'is-invalid' : $v.lastName.$error || errors.lastName.length}">
                        <div class="invalid-feedback" v-if="!$v.lastName.$required">
                            Please enter your last name!
                        </div>
                        <div class="invalid-feedback" v-for="(err, key) in errors.lastName" :key="key">{{ err }}</div>
                    </div>
                </div>
            </div>
            <slide-y-up-transition>
                <div class="row" v-if="showUpdate">
                    <div class="col-12 col-lg-2 ml-auto">
                        <div class="form-group">
                            <label>
                                &nbsp;
                            </label>
                            <button class="btn btn-success btn-success-gradient btn-lg btn-block" @click="update" :disabled="running">Update</button>
                        </div>
                    </div>
                </div>
            </slide-y-up-transition>
        </div>
    </div>
</template>

<script>
import {SlideYUpTransition} from 'vue2-transitions'
import api from "@/utils/api"
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";

const titles =[
    'Mr','Mrs','Ms','Miss'
]
export default {
    name: "PersonalDetails",
    components: {SlideYUpTransition},
    mixins: [validationMixin],
    data() {
        return {
            titles:titles,
            title: this.$store.getters['auth/title'],
            firstName: this.$store.getters['auth/firstName'],
            lastName: this.$store.getters['auth/lastName'],
            running: false,
            errors: {
                title: [],
                firstName: [],
                lastName: [],
            }
        }
    },
    validations: {
        title: {
            required
        },
        firstName: {
            required
        },
        lastName: {
            required
        },
    },
    computed: {
        showUpdate: function (){
            return this.$store.getters['auth/firstName'] !== this.firstName || this.$store.getters['auth/lastName'] !== this.lastName || this.$store.getters['auth/title'] !== this.title
        }
    },
    methods: {
        update() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.running = true;
            let that = this;
            
            api.updateProfile(this.firstName, this.lastName, this.title).then( () => {
                that.$toast.success("Your details updated successfully!")
                that.$store.commit('auth/setTitle', this.title);
                that.$store.commit('auth/setFirstName', this.firstName);
                that.$store.commit('auth/setLastName', this.lastName);
            }).catch((error) => {
                if (error.response.status === 400 && error.response.data.error.code === 11111) {
                    that.errors.title = error.response.data.meta.title || [];
                    that.errors.firstName = error.response.data.meta.first_name || [];
                    that.errors.lastName = error.response.data.meta.last_name || [];
                }
            }).finally(() => {
                that.running = false
            })
        }
    },
}
</script>

<style scoped>

</style>
